/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForFreshserviceIncidentManagement extends models.GovernanceConfigurationBaseForFreshservice {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForFreshserviceIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForFreshserviceIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForFreshserviceIncidentManagement>): GovernanceConfigurationForFreshserviceIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForFreshserviceIncidentManagement(), model);
        GovernanceConfigurationForFreshserviceIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForFreshserviceIncidentManagement>): GovernanceConfigurationForFreshserviceIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForFreshserviceIncidentManagement.newInstance(<GovernanceConfigurationForFreshserviceIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForFreshserviceIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForFreshserviceIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForFreshserviceIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForFreshservice.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForFreshserviceIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.alerts_mapping) {
            models.FreshserviceAlertsMapping.fixupPrototype(this.alerts_mapping);
        }
        if (this.budget_alerts_mapping) {
            models.FreshserviceBudgetAlertsMapping.fixupPrototype(this.budget_alerts_mapping);
        }
        if (this.security_alerts_mapping) {
            models.FreshserviceSecurityAlertMapping.fixupPrototype(this.security_alerts_mapping);
        }
        if (this.policy_alerts_mapping) {
            models.FreshservicePolicyMapping.fixupPrototype(this.policy_alerts_mapping);
        }
    }

    /**
     * Email Address for Requester
     */
    requester_email: string;

    /**
     * Attribute mapping for Freshservice Alert
     */
    alerts_mapping: models.FreshserviceAlertsMapping;

    /**
     * Attribute mapping for Freshservice Budget Alerts
     */
    budget_alerts_mapping: models.FreshserviceBudgetAlertsMapping;

    /**
     * Attribute mapping for Freshservice Security Alerts
     */
    security_alerts_mapping: models.FreshserviceSecurityAlertMapping;

    /**
     * Attribute mapping for Freshservice Policy Alerts
     */
    policy_alerts_mapping: models.FreshservicePolicyMapping;

}
